<template>
  <re-page
    main-content-class="login-form-wrapper"
    class="full-width flex flex-center"
  >
    <div class="login-form">
      <h2>Login as User</h2>
      <re-form>
        <re-input
          ref="email"
          v-model="loginData.username"
          label="Login"
          type="text"
          required
          :rules="rules"
        />
        <re-input
          ref="password"
          v-model="loginData.password"
          label="Password"
          type="password"
          required
          :rules="rules"
        />
        <re-button
          label="Login"
          color="main"
          :loading="isLoading"
          @click="handleLogin"
        />
      </re-form>
      <re-banner class="mt-1">
        You will be logged in as the selected user and see their exact interface, permissions, and data. All
        actions will be performed as if you were that user.
      </re-banner>
    </div>
  </re-page>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'

import { useConfig } from '@/composables/useConfig'
import ReBanner from '@/elements/ReBanner.vue'
import ReButton from '@/elements/ReButton.vue'
import ReForm from '@/elements/ReForm.vue'
import ReInput from '@/elements/ReInput.vue'
import RePage from '@/elements/RePage.vue'
import axios from '@/plugins/axios.js'
import store from '@/store'
import { Actions } from '@/store/Auth'

const router = useRouter()
const config = useConfig()

const loginData = ref({
  username: '',
  password: '',
})

const email = ref(null)
const password = ref(null)
const isLoading = ref(false)
const isValid = ref(true)

const rules = computed(() => [() => isValid.value])

const createAborter = () => {
  const controller = new AbortController()

  let timer
  return {
    controller,
    start: () => {
      timer = setTimeout(() => {
        controller.abort()
        isValid.value = false
        email.value.validate()
        password.value.validate()
      }, 1000)
    },
    success: () => {
      clearTimeout(timer)
      isValid.value = true
      router.push({ name: 'dashboard' })
      //window.location.reload()
    },
  }
}

const handleLogin = async () => {
  if (!loginData.value.username || !loginData.value.password) {
    return
  }

  isLoading.value = true

  try {
    const credentials = btoa(`${loginData.value.username}:${loginData.value.password}`)

    const aborter = createAborter()
    await store.dispatch(Actions.LOGOUT)
    await axios.get('/auth/logout')
    aborter.start()
    await axios.get('/auth/basic', {
      headers: {
        Authorization: `Basic ${credentials}`,
      },
      signal: aborter.controller.signal,
    })
    aborter.success()
  } catch (error) {
    console.error('Login failed:', error)
  } finally {
    isLoading.value = false
  }
}

onMounted(() => {
  const persona = router.currentRoute.value.query.persona
  if (persona && config.DEV_PERSONAS[persona]) {
    loginData.value.username = persona
    loginData.value.password = config.DEV_PERSONAS[persona]
    handleLogin()
  }
})
</script>

<style scoped lang="scss">
:deep(.login-form-wrapper) {
  display: flex;
  justify-content: center;
}

.login-form {
  width: 100%;
  max-width: 400px;
  padding: 2rem;

  .re-input {
    margin-bottom: 1rem;
  }

  .q-btn {
    width: 100%;
    margin-top: 1rem;
  }

  .mt-1 {
    margin-top: 1rem;
  }
}
</style>
